import { authorize, putRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function updateUserIn2nAPI(user, data) {
  const url = `${AWS_API_URL}/2n/users/${user?.Id}`;

  let formattedCards = [];
  formattedCards = data?.rfIdTagOne ? [...formattedCards, data.rfIdTagOne] : formattedCards;
  formattedCards = data?.rfIdTagTwo ? [...formattedCards, data.rfIdTagTwo] : formattedCards;

  return putRequest(url, {
    data: {
      groupIds: data?.groupsAndPermissions?.map((group) => group?.value),
      isSuspended: data?.isSuspended,
      cards: formattedCards,
      phoneNumbers: data?.phoneNumbers,
    },
  }, await authorize());
}
